import { ReactElement } from 'react';
import { ApiStatus } from '../hooks/api-status';
import classNames from '../utilities/class-names';
import './StatusDot.scss';

type StatusDotProps = {
  status: ApiStatus;
  className?: string;
};

export function StatusDot({ status, className }: StatusDotProps): ReactElement {
  return (
    <span
      className={classNames('status-dot', `status-dot-${status}`, className)}
      aria-hidden="true"
    />
  );
}
